<template>
	<div
		v-if="loaded"
		class="sal-components-global-market-barometer"
	>
		<sal-components-gmb
			:show-header="showHeader"
			:show-time-period="showTimePeriod"
			:show-grid="showGrid"
			:show-index-link="showIndexLink"
			:hide-esg="hideEsg"
			:default-view="defaultView"
			:default-category-view="defaultCategoryView"
			class="sal-components-global-market-barometer__wrapper sal-component"
			mwc-id="salGmb"
		/>
	</div>
</template>

<script>
import SalComponentsGmb from '@sal/gmb';
import SalCommonMixin from '@/mixins/sal-common';

export default {
	name: 'gmb',
	components: {
		SalComponentsGmb
	},
	mixins: [SalCommonMixin],
	props: {
		securityType: {
			type: String,
			default: 'XI'
		},
		showHeader: {
			type: Boolean,
			default: false
		},
		showTimePeriod: {
			type: Boolean,
			default: false
		},
		showGrid: {
			type: Boolean,
			default: false
		},
		showIndexLink: {
			type: Boolean,
			default: false
		},
		hideEsg: {
			type: Boolean,
			default: true
		},
		defaultView: {
			type: String,
			default: 'map'
		},
		defaultCategoryView: {
			type: String,
			default: 'performance'
		}
	}
};
</script>
